import { render, staticRenderFns } from "./CarreraDuplicar.vue?vue&type=template&id=1f95ebfa"
import script from "./CarreraDuplicar.vue?vue&type=script&lang=js"
export * from "./CarreraDuplicar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports